import { NgModule, ModuleWithProviders} from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { DefaultKeystoneAuthStorage, KeystoneAuthStorage, IKeystoneAuthStorage} from './keystone-auth.storage';
import { HttpClientModule } from "@angular/common/http";
import { KeystoneHttpClient } from "./keystone-http-client.service";

interface KeystomeModuleParams {
  isAuth?: boolean;
  baseUrl?: string;
}

@NgModule({
  imports: [
    HttpClientModule
  ],
})
 export class KeystoneHttpModule{
  public static forRoot({
    isAuth = true,
    baseUrl = ''}: KeystomeModuleParams
  ) : ModuleWithProviders {
    return {
      ngModule: KeystoneHttpModule,
      providers: [{ 
        provide: KeystoneAuthStorage,
        useClass: DefaultKeystoneAuthStorage
      },{ 
        provide: KeystoneHttpClient, 
        useFactory: (http: HttpClient, authStorage: IKeystoneAuthStorage) => {
          return new KeystoneHttpClient(http, authStorage, baseUrl);
        } ,
        deps: [HttpClient, KeystoneAuthStorage]
      }]
    };
  }
}


// WEBPACK FOOTER //
// ./src/keystone-http/keystone-http.module.ts